import assets from "./assets";
import auth from "./auth";
import documents from "./documents";
import env from "./env";
import graphQL from "./graphQL";
import notifications from "./notifications";
import organizations from "./organizations";
import projectMembers from "./projectMembers";
import projects from "./projects";
import structuredTemplates from "./structuredTemplates";
import tasks from "./tasks";
import tracking from "./tracking";
import user from "./user";
import workflows from "./workflows";

export const services = {
  env,
  auth,
  assets,
  documents,
  graphQL,
  notifications,
  organizations,
  projects,
  tasks,
  tracking,
  user,
  workflows,
  projectMembers,
  structuredTemplates,
};
